import { useEffect } from "react";
import { MainTable } from "../../../Components/Macro/MainTable/MainTable";
import { useCats } from "./CatState";
import Add from "./Add";
import Edit from "./Edit";

export const Cats = () => {

    let { columns, cats, setCat, removeCat, setEd } = useCats();
    useEffect(() => {
        setCat()
    }, [])

    return (
        <>
            <MainTable
                pcolumns={columns}
                pdata={cats}
                pageTitle={"Kategoriyalar"}
                add={<Add />}
                onDelete={removeCat}
                edit={<Edit />}
                onEdit={(item)=>{
                    setEd(item)
                }}
                setEd={setEd}
                defkey={'id'}
            />
        </>
    )
}